import cn from 'classnames';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { IMAGES } from 'src/appConfig/images';
import { PATHS } from 'src/appConfig/paths';
import { signOutAsync } from 'src/redux/auth/actions';
import commonActions from 'src/redux/commonRedux/actions';
import { IRootState } from 'src/redux/rootReducer';
// import { Navigator } from 'src/services';
import { Button, Image, NavLink, Text, View } from '../common';
import { ButtonVariant } from '../common/Button';
import BurgerButton from './BurgerButton';
import './styles.scss';

const NAV_TYPES = {
  isNavlink: 'NAV_LINK',
  isButton: 'BUTTON',
  isText: 'TEXT',
};

const Navbar: React.FC<Props> = ({ user, showSecondBurger, isAuthenticated, showSidebar, onSignOut, onSetSidebar }) => {
  const [toggleNavbar, setToggleNavbar] = useState(false);
  const navbarRef = useRef<HTMLElement>(null);

  const getUserName = () => {
    if (!user?.firstName) return 'Anonymous';
    return `${user.firstName} ${user.lastName}`;
  };

  // menu
  const navbarAuthItems = [
    // {
    //   id: 'Dev',
    //   href: PATHS.dev,
    //   label: 'Dev Components',
    //   type: NAV_TYPES.isNavlink,
    // },
    {
      id: 'UserName',
      label: getUserName(),
      type: NAV_TYPES.isText,
      onClick: () => {},
    },

    {
      id: 'LogIn',
      label: 'Log out',
      type: NAV_TYPES.isText,
      onClick: () => {
        onSignOut();
      },
    },
  ];

  const navbarUnAuthItems = [
    // {
    //   id: 'Dev',
    //   href: PATHS.dev,
    //   label: 'Dev Components',
    //   type: NAV_TYPES.isNavlink,
    // },
    // {
    //   id: 'SignUp',
    //   label: 'Sign Up',
    //   href: PATHS.signUp,
    //   type: NAV_TYPES.isNavlink,
    // },
    // {
    //   id: 'LogIn',
    //   label: 'LOG IN',
    //   type: NAV_TYPES.isButton,
    //   onClick: () => {
    //     Navigator.navigate(PATHS.signIn);
    //   },
    // },
  ];

  const renderNavItems = (item: any) => {
    switch (item.type) {
      case NAV_TYPES.isNavlink:
        return (
          <NavLink
            key={item.id}
            onClick={() => setToggleNavbar(!toggleNavbar)}
            className="cmp-navbar__end--item cmp-navbar__end--item--link"
            to={item.href}
            label={item.label}
            activeClassName="cmp-navbar__end--item--active"
          />
        );
      case NAV_TYPES.isButton:
        return (
          <Button
            key={item.id}
            variant={item.buttonVar as ButtonVariant}
            label={item.label}
            className={cn('cmp-navbar__end--button')}
            onClick={item?.onClick}
            iconPosition="left"
            icon={item?.icon}
          />
        );
      case NAV_TYPES.isText:
        return (
          <Text
            size={14}
            key={item.id}
            onClick={item.onClick}
            className={cn('cmp-navbar__end--item', { 'cmp-navbar__end--item--link': !!item.onClick })}>
            {item.label}
          </Text>
        );
      default:
        return item.label;
    }
  };

  const renderNavListItems = (items: Array<any>) => items.map(item => renderNavItems(item));

  const listItems = isAuthenticated ? navbarAuthItems : navbarUnAuthItems;
  return (
    <nav className={cn('cmp-navbar navbar jump-down')} ref={navbarRef} role="navigation" aria-label="main navigation">
      <View className="cmp-navbar__container container is-wider-screen">
        <View isRow flexGrow={1} className={cn('cmp-navbar__branch', 'navbar-brand')}>
          <BurgerButton
            className={cn('cmp-navbar__sidebar-burger', { show: showSecondBurger })}
            target="sidebar-menu"
            isActive={showSidebar}
            onClick={() => onSetSidebar(!showSidebar)}
          />

          <NavLink className={cn('justify-center')} to={PATHS.root}>
            <Image className={'cmp-navbar__logo'} src={IMAGES.logoLumisightFull} />
          </NavLink>

          <BurgerButton
            className="cmp-navbar__burger"
            target="navigation-menu"
            isActive={toggleNavbar}
            onClick={() => setToggleNavbar(!toggleNavbar)}
          />
        </View>

        <View
          renderIf={true}
          id="navigation-menu"
          className={cn('navbar-menu', {
            'is-active': toggleNavbar === true,
          })}
          flexGrow={1}>
          <View isRow className={cn('navbar-end cmp-navbar__end')}>
            {renderNavListItems(listItems)}
          </View>
        </View>
      </View>
    </nav>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;
const mapStateToProps = (state: IRootState) => ({
  user: state.auth.authUser,
  isAuthenticated: state.auth.isAuthenticated,
  showSecondBurger: state.common.showSecondBurger,
  showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = {
  onSignOut: signOutAsync.request,
  onSetSidebar: commonActions.setSidebar,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
